<template>
    <div class="hero-body">
        <div class="container">
            <div class="columns is-vcentered">
                <div class="column has-margin-2x">
                    <div class="columns is-centered padding-top-1x">
                        <h1 class="title is-size-1 has-text-centered-mobile uptin-text-center">
                            {{ $t('common:404.title') }}
                        </h1>
                    </div>
                    <div class="columns is-centered padding-top-1x">
                        <h2 class="is-size-6 has-text-centered-mobile uptin-text-center">
                            {{ $t('common:404.description') }}
                        </h2>
                    </div>
                    <div class="columns is-centered padding-top-1x">
                        <h2 class="is-size-6 is-bold has-text-centered-mobile uptin-text-center">
                            {{ $t('common:404.proposal') }}
                        </h2>
                    </div>
                    <div class="columns is-centered padding-top-2x">
                        <div class="content uptin-text-center has-padding-1x">
                            <a class="button uptin-splash-button is-background-dark3" href="/home">
                                {{ $t('common:404.button') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style lang="scss">

.uptin-text-button-linear {
    width: 14em;
    height: 2.8em;
    background-size: 1800% 1800%;
    overflow: hidden;
    animation: rainbow 10s ease infinite;
    border: none !important;
    //border-radius: 0.7em;
    //border: 2px solid black;
}

</style>


<script>

export default {
    components: {},
    name: 'not-found-page',
    data() {
        return {}
    },
    methods: {
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }
    }
}
</script>
